import { render, staticRenderFns } from "./ThreeDots.vue?vue&type=template&id=2ce5578a&scoped=true"
import script from "./ThreeDots.vue?vue&type=script&lang=js"
export * from "./ThreeDots.vue?vue&type=script&lang=js"
import style0 from "./ThreeDots.vue?vue&type=style&index=0&id=2ce5578a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce5578a",
  null
  
)

export default component.exports